import Store from '../general/store'

interface InsightOverviewData {
  id: number
  average_occupancy: number
  peak_occupancy: number
  nr_of_not_used_workspaces: number
}

export interface Data extends InsightOverviewData {
  floors: InsightOverviewData[]
}

class InsightFloorOverview<S = any> extends Store<S> {
  readonly data: InsightOverviewData

  constructor(parent: S, data: InsightOverviewData) {
    super(parent)
    this.data = data
  }

  get id() {
    return this.data?.id ?? NaN
  }

  get avarage() {
    return this.data?.average_occupancy ?? 0
  }

  get peak() {
    return this.data?.peak_occupancy ?? 0
  }

  get numberOfUnusedWorkspaces() {
    return this.data?.nr_of_not_used_workspaces ?? 0
  }
}

class InsightOverview<R = any> extends InsightFloorOverview<R> {
  readonly data: Data

  constructor(parent: R, data: Data) {
    super(parent, data)
    this.data = data
  }

  get floors() {
    return this.data?.floors?.map((floor) => new InsightFloorOverview(this, floor))
  }
}

export default InsightOverview
